export default __webpack_public_path__ + "static/media/shouhuo.dec3fe30.png";